// department.tsx

import React from "react";
import { DisplayFilterProps } from "@me8eon/filters";
import { useTranslation } from "@me8eon/translation";
import { DataWidget } from "@me8eon/data_widget";
import { useGlobalAggregations } from "@me8eon/all_data_sources";
import { EonUiDropdown, EonUiDropdownOption } from "@eon-ui/eon-ui-components-react";
import { EonUiDropdownCustomEvent } from "@eon-ui/eon-ui-components";

export function SimpleDisplayDepartmentTypeFilter({
    filterOps,
    rootId,
    filterName,
    value,
}: DisplayFilterProps<string>) {
    const [filters, setFilters] = filterOps;
    const globalAggregates = useGlobalAggregations();
    const agg = filterName ? globalAggregates[filterName] : [];
    const options = Array.isArray(agg) ? agg : []; // Ensure options is always an array
    const t = useTranslation();

    return (
        <div role="radiogroup" aria-labelledby={`${rootId}-label`} data-testid={`${rootId}-mime-type-filter`}>
            <EonUiDropdown
                onValueChanged={(e: EonUiDropdownCustomEvent<string>) => {
                    setFilters(e.target.value as string);
                }}
                value={filters}
                key={rootId}
                name="time_range"
                size="normal"
                label={t(`filterPage.filterMenu.department`)}
                showSelectedItems={true}
            >
                {options.map((opt, index) => (
                    <EonUiDropdownOption key={index} value={opt} label={opt} />
                ))}
            </EonUiDropdown>
        </div>
    );
}

export const SimpleDisplayDepartmentTypeFilterAdapter: React.FC<any> = (props) => {
    const { filterOps, rootId, filterName, value } = props;
    return (
        <SimpleDisplayDepartmentTypeFilter
            filterOps={filterOps}
            rootId={rootId}
            filterName={filterName}
            value={value}
        />
    );
};

export const newPeopleFilterDataWidget: DataWidget = {
    plugin: "datawidget",
    name: "filterPeople",
    display: SimpleDisplayDepartmentTypeFilterAdapter,
};
